import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IProps {
  customerId: string;
  achAccountNumber: string | number;
  handleOnSuccess?: () => void;
  optIn: boolean;
}

export const useBalanceUpOptInMutation = ({
  customerId, achAccountNumber, handleOnSuccess, optIn,
} :IProps) => useMutation(async () => {
  const { data } = await httpService.patch(`${BASE_URL}/api/v1/user/${customerId}/account/${achAccountNumber}/overdraft`, {
    accountNumber: achAccountNumber,
    optIn,
  });
  return data;
}, {
  onSuccess: () => {
    if (handleOnSuccess) handleOnSuccess();
  },
  retry: false,
});
